export interface CustomError {
  titulo?: string
  detalle?: string
  btn?: string
  estado?: boolean
  explicacion?: string
  sugerencia?: string
  nota_pie?: string
  link?: string
  route?: string
  styleDetalle?: boolean
}

export class InfoError {
  private error: CustomError
  constructor(err: CustomError) {
    this.error = err
  }

  update(obj: CustomError) {
    return Object.assign(this.error, obj)
  }

  get detalle() {
    return this.error.detalle
  }

  get btn() {
    return this.error.btn
  }

  setbtn(btnText) {
    this.error.btn = btnText
  }

  get info() {
    return this.error
  }
}

export const ERROR = {
  // Validador
  link_invalido: new InfoError({
    titulo: 'Lo sentimos',
    detalle: 'Este link ya no es válido',
    btn: 'Volver a comenzar',
  }),
  disponibilidad: new InfoError({
    titulo: 'Lo sentimos',
    detalle: 'En este momento no podemos procesar tu solicitud.',
    sugerencia: 'Volvé a intentarlo en unos minutos',
    btn: 'Volver a comenzar',
  }),
  // Validar datos
  validacion_form: new InfoError({
    titulo: 'Lo sentimos',
    detalle: 'No pudimos validar tus datos',
    btn: 'Volver a comenzar',
  }),
  validacion_form_document: new InfoError({
    titulo: 'Lo sentimos',
    detalle:
      'Recordá tener un DNI vigente para poder continuar con esta experiencia. Si alguno de tus datos no son correctos favor ponete en contacto con nuestro centro de atención a Empresas al 0810 - 122 - 6622 o por mail a comafiempresas@comafi.com.ar o dirigite a la sucursal más cercana para actualizarlos.',
    btn: 'Volver a comenzar',
    styleDetalle: true,
  }),
  actualizacion_datos: new InfoError({
    titulo: 'Lo sentimos',
    detalle:
      'No pudimos validar tu identidad ya que alguno de tus datos no se encuentran actualizados.',
    sugerencia: 'Dirígite a la sucursal más cercana para actualizarlos.',
    btn: 'Volver a comenzar',
    nota_pie:
      'Por cualquier consulta ponete en contacto con nuestro Centro de Atención a Empresas: 0810-122-6622 | comafiempresas@comafi.com.ar | comafi.com.ar',
  }),
  // comafi sms
  codigo_sms: new InfoError({
    titulo: 'Lo sentimos',
    detalle: 'El código SMS que ingresaste no es correcto.',
    btn: 'Volver a comenzar',
  }),
  // comafi token
  codigo_token: new InfoError({
    titulo: 'Lo sentimos',
    detalle:
      'El código de tu Comafi Token Empresas que ingresaste no es correcto',
    btn: 'Volver a comenzar',
  }),
  // email
  codigo_email: new InfoError({
    titulo: 'Lo sentimos',
    detalle:
      'No se pudo validar el código, por favor comunícate con tu Oficial de Negocios.',
    btn: 'Volver a comenzar',
  }),
  reenvios_superados: new InfoError({
    titulo: 'Lo sentimos',
    detalle:
      'Superaste la cantidad de intentos permitidos. Por cuestiones de seguridad, debes volver a iniciar el proceso.',
    btn: 'Volver a comenzar',
  }),
  // generación de clave error
  generacion_clave: new InfoError({
    titulo: 'Lo sentimos',
    detalle: 'La clave que ingresaste no es válida.',
    btn: 'Volver a comenzar',
  }),
  blanqueo_clave_identificacion: new InfoError({
    titulo: 'Lo sentimos',
    detalle:
      'Has modificado la clave de acceso con éxito, pero el proceso no terminó de forma correcta ya que no pudimos blanquear tu clave de indentificación',
    sugerencia:
      'Por favor ponete en contacto con nuestro Centro de Atención a Empresas al 0810-122-6622 o por mail a comafiempresas@comafi.com.ar',
    btn: 'Volver a comenzar',
  }),
  desbloqueo_user_eBanking: new InfoError({
    titulo: 'Lo sentimos',
    detalle:
      'Has modificado la clave de acceso con éxito, pero el proceso no terminó de forma correcta ya que no pudimos desbloquear tu Usuario de eBanking Empresas',
    sugerencia:
      'Por favor ponete en contacto con nuestro Centro de Atención a Empresas al 0810-122-6622 o por mail a comafiempresas@comafi.com.ar',
    btn: 'Volver a comenzar',
  }),
  blanqueo_clave_desbloqueo_user: new InfoError({
    titulo: 'Lo sentimos',
    detalle:
      'Has modificado la clave de acceso con éxito, pero el proceso no terminó de forma correcta ya que no pudimos desbloquear tu Usuario de eBanking Empresas ni blanquear tu clave de identificación',
    sugerencia:
      'Por favor ponete en contacto con nuestro Centro de Atención a Empresas al 0810-122-6622 o por mail a comafiempresas@comafi.com.ar',
    btn: 'Volver a comenzar',
  }),
  // Existentes
  sesion_expirada: new InfoError({
    estado: true,
    titulo: 'Lo sentimos',
    detalle: 'Tu sesión ha expirado.<br> Por favor volvé a comenzar',
    btn: 'Volver a comenzar',
  }),
  facephi_error: new InfoError({
    estado: true,
    titulo: 'Algo salió mal.',
    btn: 'Intentar nuevamente',
  }),
  rsa_load_error: new InfoError({
    titulo: 'Lo sentimos',
    detalle: 'En este momento no podemos procesar tu solicitud.',
    sugerencia: 'Volvé a intentarlo en unos minutos',
    btn: 'Volver a comenzar',
  })
}

export const ERRORSNAME = {
  link_invalido: 'linkInvalido',
  disponibilidad: 'disponibilidad',
  validacion_form: 'validacionForm',
  actualizacion_datos: 'actualizacionDatos',
  codigo_sms: 'codigoSms',
  codigo_token: 'codigoToken',
  codigo_email: 'codigoEmail',
  generacion_clave: 'generacionClave',
  blanqueo_clave_identificacion: 'blanqueoClaveIdentificacion',
  desbloqueo_user_eBanking: 'desbloqueoUserEbanking',
  blanqueo_clave_desbloqueo_user: 'blanqueoClaveDesbloqueoUser',
  sesion_expirada: 'sesionExpirada',
  reenvios_superados: 'ReenviosSuperados',
  clave_incorrecta: 'La clave que ingresaste no es correcta.',
  clave_repetida: 'Ingresaste una clave ya utilizada.',
}
